/** Calendar day of an instant in the reader's own zone, so grouping matches what they see. */
export const dayKey = (iso: string | null | undefined): string => {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return String(iso);
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
};

export const SHADE_COUNT = 5;

/**
 * Assigns each distinct day a shade, newest greyest. Rows arrive newest first, so the order they
 * appear is the order of the shades; beyond SHADE_COUNT days the lightest repeats and the day
 * separator carries the distinction instead.
 */
export const buildDayShades = (
  rows: { dispatchedAt: string }[],
): Map<string, number> => {
  const shades = new Map<string, number>();
  rows.forEach((row) => {
    const key = dayKey(row.dispatchedAt);
    if (!shades.has(key)) shades.set(key, Math.min(shades.size, SHADE_COUNT - 1));
  });
  return shades;
};

/** True when this row starts a new day, so a separator can be drawn above it. */
export const startsNewDay = (
  rows: { dispatchedAt: string }[],
  index: number,
): boolean =>
  index > 0 && dayKey(rows[index].dispatchedAt) !== dayKey(rows[index - 1].dispatchedAt);
